export default __webpack_public_path__ + "static/media/gallery_04.08d8c765.jpg";